module.exports = __webpack_public_path__ + "media/images/favicon/primary/apple-icon-72x72-72f4bbd90f7995166430219bf9363da6.png";